import type { SurveyPage } from '../../fetchSurvey/types/survey';
import type { SurveyAnswers } from '../../submitSurvey/types';

export function sanitizeSkippedPageAnswers(
  pages: SurveyPage[],
  answers: SurveyAnswers,
  fromPageIndex: number,
  toPageIndex: number
): SurveyAnswers {
  if (toPageIndex <= fromPageIndex) return answers;

  const questionIdsToRemove = new Set<string>();
  for (let i = fromPageIndex + 1; i < toPageIndex; i += 1) {
    pages[i]?.questions.forEach(q => questionIdsToRemove.add(q.id));
  }

  if (questionIdsToRemove.size === 0) return answers;

  const next = { ...answers };
  questionIdsToRemove.forEach(id => {
    delete next[id];
  });
  return next;
}

export function sanitizePagesAfterIndex(
  pages: SurveyPage[],
  answers: SurveyAnswers,
  fromPageIndex: number
): SurveyAnswers {
  const questionIdsToRemove = new Set<string>();
  for (let i = fromPageIndex + 1; i < pages.length; i += 1) {
    pages[i]?.questions.forEach(q => questionIdsToRemove.add(q.id));
  }

  if (questionIdsToRemove.size === 0) return answers;

  const next = { ...answers };
  questionIdsToRemove.forEach(id => {
    delete next[id];
  });
  return next;
}
